var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"editButton",class:{ '-active': _vm.isActive }},[_c('i',{staticClass:"budicon-solid budicon-solid-pencil-writing"}),_c('span',[_vm._v("Rediger")])])
}
var staticRenderFns = []

export { render, staticRenderFns }